// extracted by mini-css-extract-plugin
export default {"bigButton":"legal-statuts_bigButton__V6kTk","subtitle":"legal-statuts_subtitle__XheYv"};